import axios from '@/plugins/axios';

/**
 * [request]
 * comportamento default de um pedido a API.
 * por default, o `method` é `get`.
 *
 * @param {Object} { method, endpoint, params: { data?, headers } }
 * @since 1.0.0
 * @category requests
 * @author Tiago Martinho
 *
*/
const handlerRequests = ({ method = 'get', endpoint, params }) => {
    return new Promise( ( resolve, reject ) => {
        axios[method]( endpoint, params?.data, params?.headers )
            .then( data => { resolve( data ); })
            .catch( error => { reject( error ); });
    });
};

/**
 * [request]
 * realiza os pedidos get a API.
 *
 * @param {String} endpoint
 * @param {Object} headers
 * @since 1.0.0
 * @category requests
 * @author Tiago Martinho
 *
*/
const get = ( endpoint, params, headers = {}) => handlerRequests({ endpoint, params: { data: { params, ...headers } } });

/**
 * [request]
 * realiza os pedidos post a API.
 *
 * @param {String} endpoint
 * @param {Object} data
 * @param {Object} headers
 * @since 1.0.0
 * @category requests
 * @author Tiago Martinho
 *
*/
const post = ( endpoint, data, headers = {}) => handlerRequests({ method: 'post', endpoint, params: { data, headers } });

/**
 * [request]
 * Realiza pedidos delete a API.
 *
 * @param {String} endpoint
 * @param {Object} data
 * @since 1.0.0
 * @category requests
 * @author Tiago Martinho
 *
*/
const deleteRequest = ( endpoint, data ) => handlerRequests({ method: 'delete', endpoint, params: { data } });

/**
 * [request]
 * fica a espera dos diversos pedidos realizados.
 *
 * @param {Promises} promises
 * @since 1.0.0
 * @category requests
 * @author Tiago Martinho
 *
*/
const all = promises => Promise.all( promises );

export {
    get,
    post,
    all,
    deleteRequest
};